import { useState, useEffect } from "react";

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return isMobile;
}

export const makeLineItem = () => ({
  id: Date.now() + Math.random(),
  type: "",
  color: "",
  sheetSize: "",
  thickness: "",
  partsPerSheet: "",
  partsNeeded: "",
});

export async function sGet(k) {
  try {
    const r = await window.storage.get(k);
    return r ? JSON.parse(r.value) : null;
  } catch {
    return null;
  }
}

export async function sSet(k, v) {
  try {
    await window.storage.set(k, JSON.stringify(v));
  } catch (e) {
    console.error("Storage:", e);
  }
}

export const fmtDate = (d) => {
  const [, m, dd] = d.split("-");
  const names = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(m)]} ${parseInt(dd)}`;
};

export const fmtDateFull = (d) => {
  const [y, m, dd] = d.split("-");
  const names = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(m)]} ${parseInt(dd)}, ${y}`;
};

export const fmtMonth = (k) => {
  const [y, m] = k.split("-");
  const names = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return `${names[parseInt(m)]} ${y}`;
};
